import React from "react";
import { SectionHeading } from "~/components/DetailsPage/components";
import { Box, Grid } from "@mui/material";
import {
  CveRiskFactors,
  CvssScore,
  RiskStatsWithDescription,
} from "~/components/vulnerabilities";

type SoftwareRiskFactorsProps = {
  riskFactorsWithDocs?: (RiskStatsWithDescription | null)[] | null | undefined;
  cvssScore?: CvssScore | null;
};

export const SoftwareRiskFactors = ({
  riskFactorsWithDocs,
  cvssScore,
}: SoftwareRiskFactorsProps) => {
  return (
    <Grid id="risk-factors" size={{ xs: 12 }}>
      <SectionHeading heading="Vulnerability insights" />
      <Box className="section-content">
        <CveRiskFactors
          id="cve-risk-factors"
          riskFactors={riskFactorsWithDocs}
        />
      </Box>
    </Grid>
  );
};
